<div class="noDataFound">

  @if (mode == 'page') {
    @if (!icon) {
      <div class="bb-no-data-found size-{{avatarSize}}"></div>
    }
    @if (!!icon) {
      <epmax-icon [name]="icon" [color]="'muted'" [isOutlined]="true" [size]="avatarSize"  class="icon-background"> </epmax-icon>
    }
    @if (label) {
      <epmax-typo [name]="labelType" [weight]="labelWeight">{{label | translate}}</epmax-typo>
    }
    @if (body) {
      <epmax-typo [name]="'body2'">{{body | translate}}</epmax-typo>
    }
    @if (dropDownActions.length > 0) {
      <div class=" radius_md flex bg-primary">
        <epmax-dropdown [typoName]="'body1'" [leftIcon]="'arrow_drop_down'" [title]="btnLabel" [typoWeight]="500" [actions]="dropDownActions" [text]="btnLabel" [icon]="'add'"
        [buttonType]="'primary'" [typoColor]="'primary'" dataAutomationId="add"></epmax-dropdown>
      </div>
    }
  }
  @if (mode == 'section') {
    <div class="noDataFound-sectionMode">
      <div class="p-3 bg-bg3 flex radius_xl">
        @if (!!iconSectinMode) {
          <epmax-icon [name]="iconSectinMode" [color]="'muted'" [isOutlined]="true"></epmax-icon>
        }
      </div>
      <div class="noDataFound-sectionMode-end">
        @if (label) {
          <epmax-typo [name]="labelType" [weight]="labelWeight">{{label | translate}}</epmax-typo>
        }
        @if (body) {
          <epmax-typo [name]="'body2'">{{body | translate}}</epmax-typo>
        }
      </div>
    </div>
  }

</div>
